import Vue from 'vue'
import Notifications from 'vue-notification'
import CookieLaw from 'vue-cookie-law'
import { VueMasonryPlugin } from 'vue-masonry'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueEasyLightbox from 'vue-easy-lightbox'

Vue.use(Notifications)
Vue.component('CookieLaw', CookieLaw)
Vue.use(VueMasonryPlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(VueEasyLightbox)
